import { render, staticRenderFns } from "./IconSvgBookmarkEmpty.vue?vue&type=template&id=d550ea0e&scoped=true&"
import script from "./IconSvgBookmarkEmpty.vue?vue&type=script&lang=js&"
export * from "./IconSvgBookmarkEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d550ea0e",
  null
  
)

export default component.exports